import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupConsultationStep } from '../../../models/consultation/consultation.model';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { ConsultationProcessService } from '../consultation-process.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { LabTestCategoryModel } from '../../../models/master-data/labtest-category.model';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';
import { GroupRecommendedLabTestService } from './group-recommended-lab-tests.service';
import { GroupRecommendedLabTestPopupComponent } from './group-recommeded-lab-tests-popup.component';
import { MdOptionSelectionChange } from '@angular/material';
import { AppMessages } from '../../../shared/constants/messages';
@Component({
  selector: 'group-recommended-lab-tests',
  templateUrl: 'group-recommended-lab-tests.component.html',
  styles: [
    `md-spinner {
      width: 24px;
      height: 24px;
      margin: 5px 10px 0px 0px;
      top: 0;
      right: 0;
      position: absolute;
    }`,
    `.form-group {
      width: 100%;
    }`,
    `.form-select, .mat-option{
      font-size: 14px
    }`
  ],
  providers: [GroupRecommendedLabTestService],

})
export class GroupRecommendedLabTestsComponent extends BaseConsultationComponent implements OnInit, OnDestroy {

  labTestsCategoriesList: LabTestCategoryModel[];
  selectedLabTestsCategory: any = null;
  labTestContentList: LabTestDataModel[];
  availableLabTestContentList = new Array<LabTestDataModel>();
  selectedLabTestContentList = new Array<LabTestDataModel>();
  tempOnAddLabTestContentList = new Array<LabTestDataModel>();
  tempOnRemoveLabTestContentList = new Array<LabTestDataModel>();
  public klass = 'medicalConditions';
  selectedSearchLabtest: LabTestDataModel;
  searchList: Array<LabTestDataModel>;
  quickSearchCtrl: FormControl;
  isSearching = false;
  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public utility: Utility,
    public activeRouter: ActivatedRoute,
    public groupRecommendedLabTestService: GroupRecommendedLabTestService) {
    super(dialogService, consultationProcessService, router, activeRouter, GroupConsultationStep.RecommendedLabTests, true);
    this.quickSearchCtrl = new FormControl();
    this.quickSearchCtrl.valueChanges.subscribe(keyword => {
      if (keyword) {
        if (keyword.length > 2) {
          if (this.isSearching) { return; }
          this.isSearching = true;
          this.groupRecommendedLabTestService.quickSearchLabTest(keyword, false).subscribe(result => {
            this.isSearching = false;
            if (result) {
              const data = result.json();
              const tempArr = data;
              this.searchList = [];
              if (this.selectedLabTestContentList.length) {
                let i = 0;
                const lens = tempArr.length;
                while (i < lens) {
                  const index = this.selectedLabTestContentList.findIndex(x => x.labTestCategoryId === tempArr[i].labTestCategoryId
                    && x.centreLabtestId === tempArr[i].centreLabtestId);
                  if (index < 0) {
                    this.searchList = this.searchList.concat(tempArr[i]);
                  }
                  i++;
                }
              } else {
                this.searchList = tempArr;
              }
            }
          }, error => { this.isSearching = false; });
        }
      }
    });
  }

  ngOnInit() {
    this.groupRecommendedLabTestService.getRecommendLabTest(this.filterParam.id).subscribe(result => {
      if (result) {
        const data = result.json();
        this.selectedLabTestContentList = data;
      }
    });
    this.groupRecommendedLabTestService.getLabTestsCategories().subscribe(result => {
      if (result) {
        const data = result.json();
        this.labTestsCategoriesList = data;
        const index = this.labTestsCategoriesList.findIndex(item => item.isSelected === true);
        this.selectedLabTestsCategory = (index > -1) ? this.labTestsCategoriesList[index].id : null;
        
        this.getAvailableLabTestContentList(this.selectedLabTestsCategory); 
      }
    });
    
  }

  getAvailableLabTestContentList(labTestId: string) {
    if (labTestId) {
      this.availableLabTestContentList = new Array<LabTestDataModel>();
      let newArr = new Array<LabTestDataModel>();
      this.groupRecommendedLabTestService.getLabTests(labTestId).subscribe(result => {
        if (result) {
          newArr = result.json();
          let i = 0;
          if (newArr) {
            while (i < newArr.length) {
              let temp = null;
              temp = this.selectedLabTestContentList.find(x => x.labTestId === newArr[i].labTestId);
              if (temp === undefined || temp === null) {
                this.availableLabTestContentList = this.availableLabTestContentList.concat(newArr[i]);
              }
              i++;
            }
            this.availableLabTestContentList = this.sortArray(this.availableLabTestContentList);
          }
        }
      });
    } else {
      this.availableLabTestContentList = new Array<LabTestDataModel>();
    }
  }

  sortArray(list: LabTestDataModel[]) {
    if (list) {
      list.sort((n1, n2) => {
        if (n1.labTestName > n2.labTestName) {
          return 1;
        }
        if (n1.labTestName < n2.labTestName) {
          return -1;
        }
        return 0;
      });
      return list;
    }
    return list;
  }

  changeCategory() {
    const idCategory = this.selectedLabTestsCategory ? this.selectedLabTestsCategory : null;
    this.getAvailableLabTestContentList(idCategory);
    this.tempOnAddLabTestContentList = new Array<LabTestDataModel>();
  }

  removeFromList(labTestContentId, list: LabTestDataModel[]) {
    if (list) {
      let temp = -1;
      temp = list.findIndex(x => x.labTestId === labTestContentId);
      list.splice(temp, 1);
    }
    return list;
  }

  onChecking(labTestContent: LabTestDataModel, list: LabTestDataModel[]) {
    let temp = -1;
    if (list) {
      temp = list.findIndex(x => x.labTestId === labTestContent.labTestId);
    } else {
      list = new Array<LabTestDataModel>();
    }
    if (temp < 0) {
      list.push(labTestContent);
    } else {
      list.splice(temp, 1);
    }
  }

  onAddLabTestContentList(tempList: LabTestDataModel[]) {
    if (tempList) {
      let i = 0;
      while (i < tempList.length) {
        let temp = null;
        temp = this.selectedLabTestContentList.find(x => x.labTestId === tempList[i].labTestId);
        if (temp === null || temp === undefined) {
          this.availableLabTestContentList = this.removeFromList(tempList[i].labTestId, this.availableLabTestContentList);
          this.selectedLabTestContentList.push(tempList[i]);
        }
        i++;
      }
      this.selectedLabTestContentList = this.sortArray(this.selectedLabTestContentList);
      this.tempOnAddLabTestContentList = new Array<LabTestDataModel>();
    }
  }

  onRemoveLabTestContentList(tempList: LabTestDataModel[]) {
    if (tempList) {
      let i = 0;
      while (i < tempList.length) {
        let temp = null;
        temp = this.availableLabTestContentList.find(x => x.labTestId === tempList[i].labTestId);
        if (temp === null || temp === undefined) {
          this.selectedLabTestContentList = this.removeFromList(tempList[i].labTestId, this.selectedLabTestContentList);
          const categoryId = this.selectedLabTestsCategory ? this.selectedLabTestsCategory : null;
          if (categoryId) {
            if (tempList[i].labTestCategoryId === this.selectedLabTestsCategory) {
              this.availableLabTestContentList.push(tempList[i]);
            }
          }
        }
        i++;
      }
      this.availableLabTestContentList = this.sortArray(this.availableLabTestContentList);
      this.tempOnRemoveLabTestContentList = new Array<LabTestDataModel>();
    }
  }

  submitData() {
    if (this.isMoveNextStep) {
      let message = AppMessages.labTest.finishGroup;
      if (this.router.url.includes('group-template-recommended-lab-tests')) {
        message = AppMessages.labTest.finishGroupTemplate;
      }
      this.dialogService.openConfirmationDialog({ message: message }).subscribe(result => {
        /*  this.dialogService.openComponentDialog(GroupRecommendedLabTestPopupComponent,
           'This is the end of group consultation, next stage will be in individual'
           , { width: '350px' }).subscribe(result => { */
        if (result) {
          this.groupRecommendedLabTestService.updateLabTest(this.filterParam.id, this.selectedLabTestContentList, this.isMoveNextStep).subscribe(
            (resultupdate) => {
              if (resultupdate) {
                // call API success
                this.navigateAction();
              }
            }
          );
        }
      });
    } else {
      this.groupRecommendedLabTestService.updateLabTest(this.filterParam.id, this.selectedLabTestContentList, false).subscribe(
        (resultupdate) => {
          if (resultupdate) {
            // call API success
            this.navigateAction();
          }
        }
      );
    }

  }

  addLabTestFromSearch(event: MdOptionSelectionChange, labtest: LabTestDataModel) {
    if (labtest) {
      let index = this.availableLabTestContentList.findIndex(x =>
        x.labTestCategoryId === labtest.labTestCategoryId && x.labTestId === labtest.labTestId);
      if (index > -1) {
        this.availableLabTestContentList.splice(index, 1);
      }
      index = this.selectedLabTestContentList.findIndex(x => x.labTestId === labtest.labTestId
        && labtest.labTestCategoryId === x.labTestCategoryId);
      if (index < 0) {
        this.selectedLabTestContentList.push(labtest);
      }
      this.quickSearchCtrl.setValue('');
      this.searchList = [];
      this.selectedLabTestContentList = this.sortArray(this.selectedLabTestContentList);
    }
  }

  // Override navigate base consultation
 navigateAction()  {
    if (this.isMoveNextStep) {
      this.router.navigate([this.navigateUrl]);
    } else {
      this.router.navigate([this.navigateUrl, this.filterParam.id]);
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/group-recommended-lab-tests/group-recommended-lab-tests.component.ts